import React from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Grid,
  TextField,
  Box,
} from "@mui/material";
import { AccountBalanceOutlined } from "@mui/icons-material";
import { useFormik } from "formik";
import * as yup from "yup";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch, useSelector } from "react-redux";

//Services
import AvailablebanksApi from "Services/Availablebanks";

const AddBanks = (props) => {
  const { openDialog, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );

  const handleAddBanks = (formValues) => {
    dispatch(showLoader("Loading please wait..."));

    const data = {
      bankName: formValues?.bankName,
      branchCode: formValues?.branchCode,
      demoaccount_id: demoaccount_id || "",
    };

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Bank info added Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik.resetForm();
        handleClose();
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while creating Bank",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    AvailablebanksApi.addBanks({ ...data }).then(onSuccess, onFailure);
  };

  const formik = useFormik({
    initialValues: {
      bankName: "",
      branchCode: "",
    },
    validationSchema: yup.object({
      bankName: yup.string().required("Bank Name is required").nullable(),
      branchCode: yup.string().required("Branch Code is required").nullable(),
    }),
    enableReinitialize: true,
    onSubmit: handleAddBanks,
  });

  return (
    <Dialog
      open={openDialog}
      onClose={() => {
        formik.resetForm();
        handleClose();
      }}
      classes={{ paper: classes.dialogPaper }}
    >
      <Box className={classes.headerContainer}>
        <Typography className={classes.dialogTitle}>Add Bank</Typography>
        <Typography className={classes.breadcrumb}>
          Admin / <span>Available Banks</span>
        </Typography>
      </Box>

      <DialogContent style={{ padding: 0 }}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={3}>
            {/* Bank Name */}
            <Grid item xs={12} md={6}>
              <Typography className={classes.formLabel}>Bank Name</Typography>
              <TextField
                name="bankName"
                placeholder="e.g. State Bank"
                value={formik.values.bankName}
                onChange={formik.handleChange}
                error={formik.touched.bankName && Boolean(formik.errors.bankName)}
                helperText={formik.touched.bankName && formik.errors.bankName}
                fullWidth
                variant="outlined"
                size="small"
                className={classes.formInput}
              />
            </Grid>

            {/* Branch Code */}
            <Grid item xs={12} md={6}>
              <Typography className={classes.formLabel}>Branch Code</Typography>
              <TextField
                name="branchCode"
                placeholder="e.g. SBIN0001234"
                value={formik.values.branchCode}
                onChange={formik.handleChange}
                error={formik.touched.branchCode && Boolean(formik.errors.branchCode)}
                helperText={formik.touched.branchCode && formik.errors.branchCode}
                fullWidth
                variant="outlined"
                size="small"
                className={classes.formInput}
              />
            </Grid>
          </Grid>

          <Box className={classes.dialogActions}>
            <Button
              className={classes.cancelButton}
              onClick={() => {
                formik.resetForm();
                handleClose();
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              className={classes.submitButton}
            >
              <AccountBalanceOutlined style={{ fontSize: "18px" }} />
              Add Bank
            </Button>
          </Box>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddBanks;
